
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.156 8h6.375l.313.469 1.656 2.563 1.656-2.563.313-.469h6.375l-1 1.531L15.688 16l4.156 6.469 1 1.531h-6.375l-.313-.469-1.656-2.563-1.656 2.563-.313.469H4.156l1-1.531L9.312 16 5.156 9.531zm3.657 2l3.875 6-.344.531L7.813 22h1.656l2.188-3.438.844-1.313.844 1.313L15.533 22h1.656l-3.875-6 .344-.531L17.189 10h-1.656l-2.188 3.438-.844 1.313-.844-1.313L9.469 10H7.813zm17.156 9h.063a2.987 2.987 0 012.969 2.969c0 .976-.478 1.885-1.281 2.438l-2.125 1.469c-.041.028-.025.093-.063.125h3.469v2h-6v-1a3.38 3.38 0 011.469-2.781l2.125-1.469a.927.927 0 00.406-.781.955.955 0 00-.969-.969h-.063a.955.955 0 00-.969.969v.031h-2v-.031a2.987 2.987 0 012.969-2.969z"}})])
          )
        }
      }
    